module.exports = __webpack_public_path__ + "static/media/a-6.94d91933.jpg";